// extracted by mini-css-extract-plugin
export default {"toolbar":"XrlML5od_T"};